import { AxiosInstance } from "axios";

export const SetResponseInterceptor = (instance: AxiosInstance) => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      // Check for session expiration (401 or 403 status codes)
      if (error.response?.status === 401 || error.response?.status === 403) {
        // Clear session data
        localStorage.removeItem('sessionId');
        
        // Redirect to session timeout page
        window.location.href = '/session-timeout';
      }
      
      return Promise.reject(error);
    }
  );
};
